import Typography from '@/ui/components/typography'
import RemoveIcon from '@/assets/images/remove.svg?react'
import { FilterLabelContainer, CloseButton } from './FilterLabel.styles'
import { FilterLabelProps } from './FilterLabel.types'
import { FC } from 'react'

const FilterLabel: FC<FilterLabelProps> = ({
    filterName,
    filters,
    onRemove,
}) => {
    const label =
        filters.length === 1 ? filters[0].name : `${filters.length} Selected`

    const handleRemove = (e: React.MouseEvent<HTMLButtonElement>) => {
        e.stopPropagation()
        onRemove({ filterName, filters })
    }

    if (filters.length === 0) {
        return null
    }

    return (
        <FilterLabelContainer data-testid="filter-label">
            <Typography variant="s-regular" component="span">
                {filterName}:
            </Typography>
            <Typography
                variant="s-semibold"
                component="span"
                whiteSpaceRule="nowrap"
            >
                {label}
            </Typography>
            <CloseButton
                onClick={handleRemove}
                aria-label="Remove filter"
                data-testid={`remove-filter-label-${filterName.toLowerCase()}`}
            >
                <RemoveIcon />
            </CloseButton>
        </FilterLabelContainer>
    )
}

export default FilterLabel
